<template>
    <div>
        <div class="custom-selector">
            <div class="selector-box">
                {{projectName}}
            </div>
        </div>
        <ul class="selector-list">
            <li class="selector-item"
                v-for="elem in data"
                :key="elem.project_id"
                :class="{'selector-item-inactive' : elem.is_active !== '1'}"
                @click="updateValue(elem.project_id, elem.full_name)">{{elem.full_name}}</li>
            <li class="selector-item"  @click="updateValue(-1)">Add new</li>
        </ul>
    </div>
</template>

<script>
export default {
    name: "mySelector",
    props: ['data', 'currentValue'],
    data: () => ({
        project_name : "Choose one"
    }),
    methods:{
        updateValue(id, name){
            const selector = document.querySelector(".custom-selector");
            const list = document.querySelector(".selector-list");
            selector.classList.remove("custom-selector-active");
            list.classList.remove("selector-list-active");
            this.project_name = name;
            this.$emit("change", id);
        }
    },
    computed: {
      projectName() {

          if (this.data && this.data.length > 0 && this.currentValue > 0)
              return this.data.filter((el) => el.project_id === this.currentValue)[0].full_name
          else
              return "Choose one"
      },
    },
    mounted() {

        const selector = document.querySelector(".custom-selector");
        const list = document.querySelector(".selector-list");
        selector.addEventListener("click", () => {
            selector.classList.toggle("custom-selector-active");
            list.classList.toggle("selector-list-active")
        })
    },
}
</script>

<style scoped>
    .custom-selector {
        width: 100%;
        height: 40px;
        border: 1px solid #344675;
        border-radius: 5px;
        background-color: transparent;
        display: block;
        position: relative;
    }
    .custom-selector-active {
        border: 1px solid #e14eca;
    }
    .selector-box {
        padding-left: 20px;
        position: absolute;
        top: 50%;
        left:0;
        transform: translate(0, -50%);
        width: 100%;
        cursor: pointer;
        display: flex;
    }
    .selector-box::after {
        content: ">";
        width: 20px;
        position: absolute;
        top: 50%;
        left:100%;
        transform: translate(-20px, -50%);
    }
    .selector-list {
        list-style: none;
        margin: 0 15px 0 15px;
        padding: 15px;
        border: 1px solid #344675;
        border-radius: 5px;
        height: 0;
        opacity:0;
        pointer-events: none;
        overflow-y: auto;
    }
    .selector-list-active {
        display: block;
        pointer-events: auto;
        opacity:1;
        height: 250px;
    }
    .selector-item {
        font-size: 15pt;
        border-bottom: 1px solid #344675;
        padding-left: 10px;
        cursor: pointer;
    }
    .selector-item-inactive {
        color: #6c757d!important;
    }
</style>
